import { useMemo } from 'react';

import type { DomainQueryOptions } from '@/domain/shared/types';
import { useWelfareController_getFullWelfare } from '@/services/hooks';
import type { BwWelfareResponse } from '@/services/types';

import { mapFullWelfareResponseToDomain } from './mappers';
import type { GetFullWelfareParams, UseGetFullWelfareResult } from './types';

export const useGetFullWelfare = (
    cageId: number,
    params: GetFullWelfareParams,
    options?: DomainQueryOptions<BwWelfareResponse>
): UseGetFullWelfareResult => {
    const apiParams = {
        ...params,
        from: params.from,
        to: params.to,
    };
    const getFullWelfareQuery = useWelfareController_getFullWelfare(cageId, apiParams, options);

    const fullWelfare = useMemo(
        () => mapFullWelfareResponseToDomain(getFullWelfareQuery.data?.data),
        [getFullWelfareQuery.data?.data]
    );

    return {
        ...getFullWelfareQuery,
        isLoading: getFullWelfareQuery.isPending,
        data: fullWelfare,
    };
};
